module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.library.js
// module id = 34
// module chunks = 1